export default {
  TITLE: 'title',
  CTA: 'callToActionText'
};
